import { useGetStructuralEngineeringsQuery, useStructuralId, useProjectId } from '@consigli/hooks';
import { StructuralType } from '@consigli/types';

import { PackageList } from './package-list';

export const StructuralPackageList = () => {
  const projectId = useProjectId();
  const structuralId = useStructuralId();

  const { data: structural = [] } = useGetStructuralEngineeringsQuery({
    projectId,
    type: StructuralType.STRUCTURAL,
  });

  return <PackageList packages={structural} id={structuralId} />;
};
